var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('create-view',{attrs:{"store":"bundle","update-route":"BundleUpdate"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('form-input',{staticClass:"col-3",attrs:{"store":slotProps.store,"prop-name":"name"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }